import { Attachment } from 'components/lib/icons'
import React from 'react'

export default function AttachmentIconButton({
  isDisabled,
  open,
}) {
  return (
    <button
      aria-label="Click to add an attachment"
      className='drift-widget-composer-file-attachment'
      disabled={isDisabled}
      onClick={open}
    >
      <Attachment />
    </button>
  )
}
